import React, { useState, useEffect } from 'react';
import './styles.css';
import MainLayout from '../../components/layouts/MainLayout';
import { useGlobalContext } from '../App/context';
import DashboardRoutes from '../../routes/DashboardRoutes/DashboardRoutes';
import { localStorageService } from '../../utils/localStorageService';
import { STORAGE_KEYS } from '../../constants/storage';
import FirstTimeEntry from '../../components/FirstTimeEntry';
import SwitchEnv from '../../components/SwitchEnv';

const Dashboard = () => {
  const [isConfirm, setIsConfirm] = useState(localStorageService.getItem(STORAGE_KEYS.getMeData) === 'set');
  const { getMeData, getMeStopPolling, isCustomerSupportRole } = useGlobalContext();
  const isReady = !!getMeData && isConfirm;

  useEffect(() => {
    getMeStopPolling();
  }, [getMeStopPolling]);

  useEffect(() => {
    if (getMeData) {
      localStorageService.setItem(STORAGE_KEYS.getMeData, 'set');
      setIsConfirm(true);
    }
  }, [getMeData]);

  return (
    <>
      <MainLayout>{isReady && <DashboardRoutes />}</MainLayout>
      <FirstTimeEntry />

      {!isCustomerSupportRole && <SwitchEnv />}
    </>
  );
};

export default Dashboard;
